// extracted by mini-css-extract-plugin
export default {"container":"sales-banner_container","title":"sales-banner_title"};